import axios from "axios";
import CONFIG from "../config";
import axiosInstance from "./https/global";

const baseUrl = `${CONFIG.BASE_URL}/wayapay-identity-manager/api/v1`;
const MAX_PAGE_SIZE = 100;

const toKycError = (error) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const base = typeof data === "object" && data !== null ? data : { message: data };
    // A real Error so the stack survives and `instanceof Error` holds; the
    // backend body and HTTP status ride along as properties.
    const err = new Error(base.message ?? "Request failed");
    Object.assign(err, base, { statusCode: error.response?.status });
    return err;
  }
  return new Error("An unexpected error occurred");
};

export const approveKYC = async (merchantId) => {
  try {
    const { data } = await axiosInstance.post(
      `${baseUrl}/waya-merchant/business-kyc/${merchantId}/change-status/APPROVED`,
    );

    return data;
  } catch (error) {
    throw toKycError(error);
  }
};

export const rejectKYC = async (merchantId, reasonForRejection) => {
  try {
    const { data } = await axiosInstance.post(
      `${baseUrl}/waya-merchant/business-kyc/${merchantId}/change-status/REJECTED`,
      null,
      {
        params: {
          reasonForRejection,
        },
      },
    );

    return data;
  } catch (error) {
    throw toKycError(error);
  }
};

export const getKycList = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = Math.min(Number(params.size) || 10, MAX_PAGE_SIZE);
  if (params.order !== undefined) queryParams.order = params.order;
  if (params.approvalStatus !== undefined)
    queryParams.approvalStatus = params.approvalStatus;
  if (params.businessType !== undefined)
    queryParams.businessType = params.businessType;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/waya-merchant/business-kyc`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    throw toKycError(error);
  }
};

export const getBusinessKycDirector = async ({ merchantId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/waya-merchant/business-kyc/fetchDirectorKyc`,
      { params: { merchantId } },
    );
    return response.data;
  } catch (error) {
    throw toKycError(error);
  }
};

export const getBusinessKyc = async ({ merchantId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/waya-merchant/business-kyc/${merchantId}`,
    );
    return response.data;
  } catch (error) {
    throw toKycError(error);
  }
};
